import { FC, ReactNode } from "react";

import { Box, Chip, LinearProgress, Typography, useTheme } from "@mui/material";

import { Translate } from "@/components/Application/Translate";

type WrapperHeadingRightProps = {
	/** 0–100; if provided, shows a compact labeled progress bar */
	progress?: number;
	/** Optional content on the far right (filters, buttons, etc.) */
	rightContent?: ReactNode;
};

export const WrapperHeadingRight: FC<WrapperHeadingRightProps> = ({
	rightContent,
}) => {
	return (
		<Box
			className="heading-wrapper"
			sx={{
				display: "flex",
				alignItems: { xs: "stretch", sm: "center" },
				gap: 2,
				justifyContent: "space-between",
				px: { xs: 0, sm: 0 },
				py: { xs: 1, sm: 1 },
				borderBottom: (t) => `1px solid ${t.palette.divider}`,
			}}
		>
			{/* Left: Title + subtle subtitle */}
			<Box sx={{ minWidth: 0 }}>
				<Typography
					variant="h5"
					component="h1"
					sx={{ fontWeight: 800, lineHeight: 1.2 }}
				>
					<Translate
						className="heading"
						String="Procedures.ActiveProcedures.Heading"
					>
						Active procedures
					</Translate>
				</Typography>

				<Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
					<Translate String="Procedures.ActiveProcedures.Subtitle">
						Monitor progress and completion status
					</Translate>
				</Typography>
			</Box>

			{/* Right: custom right content */}
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 1.5,
					minWidth: 200,
					ml: "auto",
				}}
			>
				{rightContent}
			</Box>
		</Box>
	);
};
